import React from "react";
import close from "../../assets/images/close.svg";
import annualsummary1 from "../../assets/images/annualSummary1.png";
import annualsummary2 from "../../assets/images/annualSummary2.png";

function ReportInfoPopup({ handleshowPopup }) {
  return (
    <div className="ReportInfoPopup-main schedular-popup password-locker-popup">
      <div className="popup-title">
        <h2>Annual Summary</h2>
        <img
          src={close}
          alt="close"
          className="cursor-pointer"
          onClick={(e) => {
            handleshowPopup(e);
          }}
        />
      </div>
      <div className="popup-body report-popup-body">
        <img src={annualsummary1} alt="annualsummary1" className="mb10"/>
        <h6>On The Books</h6>
        <p>
          'OTB' stands for on the books. Hoteliers use it when looking ahead to
          see how many rooms are booked at which rates for a given day. In
          short, it shows the current confirmed occupancy and revenue for the
          future.
        </p>
        <h6>Net STLY</h6>
        <p>
          Net STLY Stands for "Net Same Time Last Year" and the column shows
          everything booked at the same time last year, net of any reservation
          that didn't actualize such as cancellation and no-show.
        </p>
        <h6>Total LY</h6>
        <p>
          The Total Last Year column gives last year's totals of OCC, ADR, and
          REV at this exact point in time.
        </p>
        <h6>Budget</h6>
        <p>
          The Budget is the hotel's revenue goal. Here it is shown by month.
          When a total room revenue budget is inputted, ADR and OCC are
          automatically calculated and populated into this module. To input the
          Budget, navigate to Hotel Configuration by clicking the 'gear' icon
          and selecting the User Forecast tab.
        </p>
        <h6>Forecast</h6>
        <p>
          Forecast is based on the pro priority statistical model of 90 days of
          reservation data that takes many things into account, such as day of
          the week, lead time, booking window, high vs low demand, days,
          seasonality, last year, total, and year over year Pace.
        </p>
        <h6>OCC</h6>
        <p>
          The Total Last Year column gives last year's totals of OCC, ADR, and
          REV Occupancy is calculated by the number of occupied rooms divided by
          the number of available rooms that physically exist in a hotel.at this
          exact point in time.
        </p>
        <h6>RMS</h6>
        <p>The number of rooms available for a hotel to sell or distribute.</p>
        <h6>ADR</h6>
        <p>
          The average daily rate (ADR) measures the average revenue earned for
          an occupied room per day. Average Daily Rate = Number of Rooms Sold /
          Rooms Revenue Earned
        </p>
        <h6>REV</h6>
        <p>
          The total amount of money that a Hotel earns through selling Rooms,
          over a time period (a day, week, month or year).Rev = total room sold
          / adr
        </p>
        <h6>Annual Summary Chart</h6>
        <img src={annualsummary2} alt="annualsummary2" />
        <p>
          This chart presents a month-by-month comparison of actual revenue
          (OTB), projected revenue (Forecast), and target revenue (Budget) for
          the year. The green bars show the revenue actually earned each month,
          the blue bars indicate what we expected to earn, and the gray dots
          represent our revenue goals. A green bar surpassing the gray dot means
          we exceeded our revenue target for that month, showcasing our
          financial success and strategic forecasting accuracy.
        </p>
      </div>
    </div>
  );
}

export default ReportInfoPopup;
